import { useComputedCompany } from "Components/Company/hooks/useComputedCompany";
import { ValidMember } from "Components/Members/MembersHelper";
import { useSchedule } from "Components/Schedule/hooks/useSchedule";
import { useScheduleResources } from "Components/ScheduleResource/hooks/useScheduleResources";
import {
	IsCalendarSubHeadOpen,
	SetIsCalendarSubHeadOpen,
} from "Helpers/LocalStorageHelper";
import { ScheduleGroup, ScheduleResource } from "domain-entities";
import React, { FC, Fragment } from "react";
import CalendarSubHeadRow from "./CalendarSubHeadRow";

interface Props {
	isCalendarSubHeadOpen: IsCalendarSubHeadOpen;
	setIsCalendarSubHeadOpen: SetIsCalendarSubHeadOpen;
	renderMemberRow: (member: ValidMember) => JSX.Element;
	renderResourceRow: (scheduleResource: ScheduleResource) => JSX.Element;
}

const CalendarGroupRows: FC<Props> = (props) => {
	const scheduleResources = useScheduleResources((state) => state.items);
	const scheduleGroups = useSchedule((state) => state.item?.groups);
	const validMembers = useComputedCompany((state) => state.validMembers);

	function renderRows(scheduleGroup: ScheduleGroup) {
		return scheduleGroup.items.reduce<JSX.Element[]>(
			(result, scheduleGroupItem) => {
				if (scheduleGroupItem.userId) {
					const validMember = validMembers.find(
						(validMember) => validMember.id === scheduleGroupItem.userId
					);

					if (validMember) {
						result.push(props.renderMemberRow(validMember));
					}
				} else if (scheduleGroupItem.resourceId) {
					const resource = scheduleResources.find(
						(scheduleResource) =>
							scheduleResource.id === scheduleGroupItem.resourceId
					);

					if (resource) {
						result.push(props.renderResourceRow(resource));
					}
				}

				return result;
			},
			[]
		);
	}

	function renderGroups() {
		return scheduleGroups?.map((scheduleGroup) => {
			return (
				<Fragment key={scheduleGroup.id}>
					<CalendarSubHeadRow
						title={scheduleGroup.name}
						isOpen={props.isCalendarSubHeadOpen[scheduleGroup.id]}
						setIsOpen={(isOpen) =>
							props.setIsCalendarSubHeadOpen(scheduleGroup.id, isOpen)
						}
					/>
					{props.isCalendarSubHeadOpen[scheduleGroup.id] &&
						renderRows(scheduleGroup)}
				</Fragment>
			);
		});
	}

	return <Fragment>{renderGroups()}</Fragment>;
};

export default CalendarGroupRows;
